<template>
  <div>
    <v-card elevation="0" class="px-7">
      <v-row dense align="center" justify="space-between">
        <v-col cols="12" sm="6">
          <h1 class="fs-16 primary--text font-weight-bold">
            Sponsorship Reports
          </h1>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-breadcrumbs class="app-breadcrumbs py-3" :items="breadcrumbs" />
        </v-col>
      </v-row>
    </v-card>

    <v-container class="px-7" fluid>
      <v-row no-gutters align="center" class="mb-3">
        <v-col v-if="hasFilterParams" cols="auto">
          <v-btn exact to="/sshcf/dashboard" icon color="bluedarken">
            <v-icon class="icon-bold">mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6">
          <h1 class="fs-20 font-weight-bold bluedarken--text">
            Sponsorship Reports
          </h1>
        </v-col>
        <v-spacer />
        <v-col cols="12" sm="auto">
          <v-btn color="primary" icon large>
            <v-icon
              @click="syncData"
              class="icon-large icon-bold"
              color="bluedarken"
            >
              mdi-refresh
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-card :loading="loading" class="elevation-card rounded-12 mb-5">
        <v-card-title>
          <div class="mr-2">
            <v-img
              src="@/assets/images/icon-file-text.png"
              width="20"
              height="20"
            />
          </div>
          <span class="fs-14 font-weight-bold primary2--text">
            Sponsorship Reports
          </span>
          <v-spacer />
          <v-menu
            width="220"
            nudge-right="-70"
            :close-on-content-click="false"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                class="btn-medium mr-4"
                color="#D9E7FC"
                v-bind="attrs"
                v-on="on"
              >
                Select Column
                <v-icon class="mr-1">mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-card width="220" class="mx-auto">
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox v-model="isSelectedAll"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ isSelectedAll ? 'Unselect All' : 'Select All' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item-group v-model="columnActive" multiple>
                  <template v-for="(item, i) in headers">
                    <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>
                    <v-list-item v-else :key="`item-${i}`" :value="item">
                      <template v-slot:default="{ active, toggle }">
                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            @click="toggle"
                          ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="item.text"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
          <v-btn
            depressed
            dark
            color="menuActive"
            class="btn-medium"
            @click="download"
          >
            Download
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-responsive>
            <v-simple-table
              fixed-header
              class="table-taxonomy nav-table sshcf-table"
            >
              <template v-slot:default>
                <VuePerfectScrollbar
                  class="drawer-menu--scroll"
                  :settings="scrollSettings"
                >
                  <thead>
                    <tr>
                      <template v-for="(header, index) in headers">
                        <th
                          v-if="isHeaderSelected(header)"
                          :key="header.text"
                          class="white--text"
                          :class="{
                            [`text-${header.align}`]: true,
                            [header.customClass]: !!header.customClass
                          }"
                        >
                          <span>{{ header.text }}</span>
                          <filter-column
                            v-if="header.value !== 'action'"
                            :indexItem="index"
                            :field="header.value"
                            :listFilter="getFiltered(header.value, index)"
                            :selected-values="getSelectedValues(header)"
                            :date="header.isDate"
                            @sortAsc="getNestedSort"
                            @searchColumn="searchCln"
                            @filterItem="searchCln"
                          />
                        </th>
                      </template>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in filteredItems" :key="index">
                      <template v-for="header in headers">
                        <td
                          v-if="isColumnSelected(header.value)"
                          :key="header.name"
                          :class="{
                            [header.tdClass]: true,
                            [`text-${header.align}`]: true,
                            [header.tdClass]: !!header.tdClass
                          }"
                        >
                          <router-link
                            v-if="header.linkable"
                            :to="`/sshcf/request/${item.form_id}`"
                            class="bluedarken--text text-link"
                          >
                            {{ item.hcf_code }}
                          </router-link>
                          <dialog-sponsorship-detail
                            v-else-if="header.value === 'action'"
                            :item="item"
                            :header="header"
                          />
                          <span v-else>
                            {{ header | tableRowValue(item) }}
                          </span>
                        </td>
                      </template>
                    </tr>
                    <tr v-if="filteredItems.length" class="total">
                      <td colspan="8">Total</td>
                      <!--                    <td colspan="4">-->
                      <!--                      {{ totalAmount | toCurrencyWithoutSign }}-->
                      <!--                    </td>-->
                      <td colspan="6">
                        {{ totalAmount | toCurrencyWithoutSign }}
                      </td>
                      <td colspan="2"></td>
                    </tr>
                    <tr v-if="!filteredItems.length">
                      <td :colspan="headers.length" class="text-center">
                        {{ loading ? 'Loading...' : 'No data available' }}
                      </td>
                    </tr>
                  </tbody>
                </VuePerfectScrollbar>
              </template>
            </v-simple-table>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import FilterColumn from '@/components/filterColumn';
import { exportToExcel, formatDate } from '@/utils/helpers';
import { exportValue, toCurrencyWithoutSign } from '@/mixins/filter';
import DialogSponsorshipDetail from '@/components/SSHCF/DialogSponsorshipDetail';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';

export default {
  components: {
    DialogSponsorshipDetail,
    FilterColumn,
    VuePerfectScrollbar
  },
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 340
    },
    breadcrumbs: [
      {
        text: 'SSHCF',
        to: '/sshcf/'
      },
      {
        text: 'Sponsorship Reports',
        to: '/sshcf/sponsorship/reports'
      }
    ],
    headers: [
      {
        text: 'SSHCF Code',
        align: 'left',
        value: 'hcf_code',
        linkable: true,
        customClass: 'sticky-header1',
        tdClass: 'sticky-body1'
      },
      {
        text: 'Preval Number',
        align: 'left',
        value: 'preval_number'
      },
      {
        text: 'IO Number',
        align: 'left',
        value: 'io_number'
      },
      {
        text: 'House',
        align: 'left',
        value: 'house'
      },
      {
        text: 'Region',
        align: 'left',
        value: 'region'
      },
      {
        text: 'District',
        align: 'left',
        value: 'district'
      },
      {
        text: 'Vendor Code',
        align: 'left',
        value: 'vendor_code'
      },
      {
        text: 'Hospital Name',
        align: 'left',
        value: 'hospital'
      },
      {
        text: 'Vendor Name',
        align: 'left',
        value: 'vendor_name'
      },
      {
        text: 'Account Number',
        align: 'left',
        value: 'account_number'
      },
      {
        text: 'Amount of Support',
        align: 'left',
        value: 'support_amount',
        formatter(value) {
          return toCurrencyWithoutSign(value);
        },
        exportFormat: val => +val
      },
      {
        text: 'Created Date',
        align: 'left',
        value: 'created_date'
      },
      {
        text: 'Start Date',
        align: 'left',
        value: 'start_date'
      },
      {
        text: 'End Date',
        align: 'left',
        value: 'end_date'
      },
      {
        text: 'Status',
        align: 'center',
        value: 'local_status'
      },
      {
        text: 'Detail',
        align: 'center',
        value: 'action'
      }
    ],
    items: [],
    filter: null,
    columnActive: [],
    loading: false
  }),
  computed: {
    hasFilterParams() {
      const query = this.$route.query;

      return query.filter_by && query.filter_value;
    },
    totalAmount() {
      return this.filteredItems.reduce(
        (total, item) => total + item.support_amount,
        0
      );
    },
    filteredItems() {
      let items = this.getFilteredItems();

      // custom filter year start and year end
      const filterYearStart = +this.$route.query.filter_year_start;
      const filterYearEnd = +this.$route.query.filter_year_end;
      if (filterYearStart && filterYearEnd) {
        items = items.filter(item => {
          const startDate = +moment(item.start_date, 'DD-MM-YYYY').year();
          return startDate >= filterYearStart && startDate <= filterYearEnd;
        });
      }

      return items;
    },
    isSelectedAll: {
      get() {
        return this.headers
          ? this.columnActive.length === this.headers.length
          : false;
      },
      set(value) {
        const selected = [];

        if (value) {
          this.headers.forEach(function(user) {
            selected.push(user);
          });
        }

        this.columnActive = selected;
      }
    }
  },
  created() {
    const query = this.$route.query;
    if (query.filter_by && query.filter_value) {
      const filter_by = query.filter_by;
      const filter_value = query.filter_value;
      const tabIndex = this.headers.findIndex(item => item.value === filter_by);
      this.filter = {
        fieldName: filter_by,
        tabIndex,
        value: [filter_value]
      };
    }
  },
  async mounted() {
    await this.selectAllColumn();
    await this.fetch();
  },
  methods: {
    syncData() {
      this.loading = true;
      this.$store.dispatch('sshcf/syncData', 'form_request');
      this.fetch();
    },
    selectAllColumn() {
      this.columnActive = this.headers;
    },
    async fetch(params = {}) {
      this.loading = true;
      const res = await this.$store.dispatch('sshcf/getSponsorshipReports', {
        ...params
      });
      this.loading = false;
      this.items = res.data.result.map(item => ({
        ...item,
        start_date: formatDate(item.start_date),
        end_date: formatDate(item.end_date),
        created_date: formatDate(item.created_date)
      }));
      this.totalItems = res.data.total_data;
    },
    onRowClicked(item) {
      this.getDetail(item.form_id);
    },
    toggleSelectAll() {
      this.isSelectAll = !this.isSelectAll;
    },
    isHeaderSelected(header) {
      return this.columnActive.map(item => item.value).includes(header.value);
    },
    isColumnSelected(name) {
      return this.columnActive.filter(item => item.value === name).length > 0;
    },
    getAscSort(obj) {
      this.items.sort(this.dynamicSort(obj.fieldName));
    },
    getNestedSort(obj) {
      this.nestedSort(obj.fieldName, this.items);
    },
    searchCln(obj) {
      this.filter = obj;
    },
    getFilteredItems() {
      const obj = this.filter;

      let arr = this.items;

      if (!obj) return arr;

      let nameField = obj.fieldName;
      let valSearch = Array.isArray(obj.value)
        ? obj.value.join('|').toLowerCase()
        : obj.value.toLowerCase();
      let result = [];
      if (!nameField.includes('.')) {
        /*search array of object*/
        if (nameField === 'start') {
          nameField = 'dateStart';
        } else if (nameField === 'end') {
          nameField = 'dateEnd';
        }
        result = arr.filter(function(a) {
          if (a[nameField] !== null) {
            if (Array.isArray(obj.value)) {
              return obj.value.includes(String(a[nameField]));
            } else {
              return a[nameField]
                .toString()
                .toLowerCase()
                .match(valSearch);
            }
          }
        });
      } else {
        /*search array of nested object*/
        let arrObj = nameField.split('.');
        if (arrObj.length === 2) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(a[arrObj[0]][arrObj[1]].toString());
              } else {
                return a[arrObj[0]][arrObj[1]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 3) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 4) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else {
          result = this.items;
        }
      }

      return result;
    },
    getFiltered(name) {
      if (!name.includes('.')) {
        return Object.keys(
          this.items.reduce((result, arr) => {
            result[arr[name]] = [...(result[arr[name]] || []), arr];
            return result;
          }, {})
        );
      } else {
        let nameField = name.split('.');
        return Object.keys(
          this.items.reduce((result, arr) => {
            if (!arr[nameField[0]]) return;
            result[arr[nameField[0]][nameField[1]]] = [
              ...(result[arr[nameField[0]][nameField[1]]] || []),
              arr
            ];
            return result;
          }, {})
        );
      }
    },
    download() {
      const headers = this.headers.filter(item => item.value !== 'action');
      const columns = headers.map(item => item.text);
      const items = this.filteredItems.map(item =>
        headers.map(header => exportValue(header, item))
      );
      const date = moment().format('YYYY-MM-DD-HHmmss');
      exportToExcel(columns, items, 'Sponsorship-Reports-' + date);
    },
    getSelectedValues(header) {
      if (!this.filter) return [];

      return header.value === this.filter.fieldName ? this.filter.value : [];
    }
  }
};
</script>

<style scoped>
.drawer-menu--scroll {
  max-height: 600px;
  overflow: auto;
}
</style>
